import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';
import Mensagem from './Mensagem';


class MensagemAgendamento extends XAPPComponent {

    render() {
        const { idfuncionalidade, xappRouteParams, className, children, callback, header } = this.props;
        const SETUP = {
            "condicao": [{ "Campo": "idagendamentopessoaformulario", "Operador": "=", "Valor": idfuncionalidade }],
            "campo": "chat",
            "function": "spvwagendamentopessoaformulario",
            "target": "agendamentopessoaformulario"
        }

        return (
            <div className="flex" onClick={ev => ev.stopPropagation()}>
                <Mensagem
                    SETUP={SETUP}
                    xappRouteParams={xappRouteParams}
                    className={className}
                    callback={callback}
                    header={header}
                >
                    {children}
                </Mensagem>
            </div>
        )
    };
}


export default MensagemAgendamento;
